import { useState } from "react";
import { Dial } from "./Dial";
import { FUNDS_LABEL, fundsKey, money, globalMin } from "./filters";

export const budgetSteps = () => [globalMin(), 1000, 2000, 3000, 5000, 10000, 15000, 25000, 50000, 100000, 250000, 500000, 1000000];
const nearestStep = (steps, v) => steps.reduce((best, s, i) => (Math.abs(s - v) < Math.abs(steps[best] - v) ? i : best), 0) + 1;

export function Option({ on, onClick, children, testId }) {
  return <button type="button" onClick={onClick} data-testid={testId} className={`flex w-full items-center justify-between rounded-xl px-4 py-3 text-left text-sm transition-colors ${on ? "bg-foreground text-background" : "hover:bg-gray6"}`}>{children}{on && <span className="text-xs">Selected</span>}</button>;
}

export function BudgetPanel({ value, cat, onChange }) {
  const [custom, setCustom] = useState("");
  const steps = budgetSteps(); const min = steps[0];
  const idx = value ? nearestStep(steps, value) : 0;
  const apply = () => { const n = parseInt(custom.replace(/\D/g, ""), 10); if (n > 0) { onChange(n); setCustom(""); } };
  return (
    <div data-testid="budget-panel">
      <p className="text-center text-lg font-semibold">What's your budget?</p>
      <p className="mt-1 text-center text-xs text-label2">Visa fee + {FUNDS_LABEL[fundsKey(cat)]} · indicative USD</p>
      <div className="mt-4">
        <Dial testId="budget-dial" value={idx || 1} max={steps.length} onChange={(i) => onChange(steps[i - 1])}
          label={{ big: money(value || min), small: value ? "total budget" : "minimum · any visa", hint: value ? `Destinations you can start under ${money(value)}` : `Cheapest visa anywhere starts at ${money(min)}. Turn to set your ceiling.` }} />
      </div>
      <div className="mt-4 flex items-center gap-2 px-2">
        <button type="button" onClick={() => onChange(0)} data-testid="budget-any" aria-pressed={!value} className={`h-11 shrink-0 rounded-xl border px-4 text-sm font-semibold transition-colors ${!value ? "border-foreground bg-foreground text-background" : "border-separator hover:border-foreground"}`}>Any budget</button>
        <label className="flex h-11 flex-1 items-center gap-2 rounded-xl border border-separator px-3 text-sm focus-within:border-tint">
          <span className="text-label2">$</span>
          <input inputMode="numeric" placeholder="Exact amount" value={custom} onChange={(e) => setCustom(e.target.value)} onKeyDown={(e) => e.key === "Enter" && apply()} className="w-full bg-transparent outline-none" data-testid="budget-custom" />
        </label>
        <button type="button" onClick={apply} className="h-11 rounded-xl bg-primary px-4 text-sm font-semibold text-primary-foreground" data-testid="budget-apply">Set</button>
      </div>
    </div>
  );
}
